import React, { useEffect, useState, createContext, Children } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
} from "react-router-dom";
import {
  Login,
  Register,
  Unauthorized,
  Dashboard,
  Collection,
  Paygo,
  DashboardAdmin,
  CollectionAdmin,
  PaygoAdmin,
  ExpenseAdmin,
  Expense,
  ParticipantsAdmin,
  Participants
} from "./pages";
import { Navbar } from "./components";
import PrivateRoute from "./config/AdminRoute";

export const AuthContext = createContext("");

function App() {
  let data = localStorage.getItem("jwt_authorization");
  data = JSON.parse(data);
  const [user, setUser] = useState(data);

  return (
    <AuthContext.Provider value={[user, setUser]}>
      <Router>
        <Navbar user={user} />
        <Routes>
          <Route path="/" element={<Login />} exact />
          <Route path="/register" element={<Register />} exact />
          <Route path="/unauthorized" element={<Unauthorized />} exact />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute roles={["user"]}>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/collection"
            element={
              <PrivateRoute roles={["user"]}>
                <Collection />
              </PrivateRoute>
            }
          />
          <Route
            path="/paygo"
            element={
              <PrivateRoute roles={["user"]}>
                <Paygo />
              </PrivateRoute>
            }
          />

          <Route
            path="/expense"
            element={
              <PrivateRoute roles={["user"]}>
                <Expense />
              </PrivateRoute>
            }
          />

          <Route
            path="/participants"
            element={
              <PrivateRoute roles={["user"]}>
                <Participants />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/dashboard"
            element={
              <PrivateRoute roles={["admin"]}>
                <DashboardAdmin />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/collection"
            element={
              <PrivateRoute roles={["admin"]}>
                <CollectionAdmin />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/paygo"
            element={
              <PrivateRoute roles={["admin"]}>
                <PaygoAdmin />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/expense"
            element={
              <PrivateRoute roles={["admin"]}>
                <ExpenseAdmin />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/participants"
            element={
              <PrivateRoute roles={["admin"]}>
                <ParticipantsAdmin />
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </AuthContext.Provider>
  );
}

export default App;
